import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const AddEditCompanyMasterForm = (
  strings: any,
  companyCategoryList: any[],
  countryList: any[],
  cityList: any[],
  assigneeList: any[],
  statusList: any[],
  industryTypeList: any[],
  accountTypes: any[],
): FormModel[] => {
  return [
    {
      label: strings.lead_management_contact_details_company_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'companyName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.lead_management_contact_details_company_category,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'companyCategory',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: companyCategoryList,
    },
    {
      label: strings.lead_management_contact_details_industry_type,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'industryType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: industryTypeList,
    },
    {
      label: strings.lead_management_type_of_account,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'accountType',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: accountTypes,
    },
    {
      label: strings.lead_management_contact_details_primaryManager,
      value: '',
      size: 'medium',
      type: 'select',
      isMulti: true,
      isClearable: true,
      variant: 'outlined',
      placeholder: strings.lead_management_contact_details_primaryManager,
      field: 'primaryManagers',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 8 },
      required: true,
      options: assigneeList,
    },
    {
      label: strings.lead_management_headquarter_details,
      value: '',
      type: 'section',
      placeholder: '',
      field: 'potential',
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },

    {
      label: strings.lead_management_headquarter_phone,
      value: '',
      size: 'medium',
      type: 'phoneInput',
      typeValue: 'phone',
      variant: 'outlined',
      placeholder: '',
      field: 'hqPhoneNo',
      validators: [{ check: Validators.validateMobile }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: false,
    },
    {
      label: strings.lead_management_headquarter_email,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'hqEmail',
      validators: [{ check: Validators.validateEmail }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: false,
    },
    {
      label: strings.lead_management_headquarter_website,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'hqWebsite',
      validators: [{ check: Validators.ValidateUrl }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: false,
    },
    {
      label: strings.lead_management_contact_details_country,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'hqCountry',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: countryList,
    },
    {
      label: strings.lead_management_contact_details_city,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'hqCity',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: cityList,
    },
    {
      label: strings.lead_management_headquarter_address,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'hqAddress',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
  ];
};
